import { combineReducers } from 'redux'
import pizza from './pizza'


export default combineReducers({
  pizza
})


// WEBPACK FOOTER //
// ./src/reducers/index.js